module.exports = __webpack_public_path__ + "static/img/window_2.0c07fc5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extend/window_2.gif
// module id = gFNZ
// module chunks = 94